import React from "react";

const OutlinedButton = ({ children, startIcon, style, ...props }) => {
  return (
    <button
      {...props}
      style={{
        backgroundColor: "white",
        color: "#FF6500",
        border: "1.5px solid #FF6500",
        borderRadius: 10,
        padding: 10,
        cursor: "pointer",
        fontWeight: 500,
        height: 44,
        fontSize: 14,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        width: "100%",
        ...style,
      }}
    >
      {startIcon}
      {children}
    </button>
  );
};
export default OutlinedButton;
